
export const DIALOG_CONFIRMATION_MOD_VERSION_TITLE = "Вы действительно хотите выполнить это действие?"

export const DIALOG_CONFIRMATION_MOD_VERSION_CONTENT = "Обратите внимание, данное действие необратимо."

export const DIALOG_CONFIRMATION_MOD_VERSION_OK_BUTTON = "Подтвердить"

export const DIALOG_CONFIRMATION_MOD_VERSION_TITLE_HIDE = "Вы действительно хотите скрыть комментарий?"

export const DIALOG_CONFIRMATION_MOD_VERSION_OK_BUTTON_HIDE = "Скрыть"

export const DIALOG_CONFIRMATION_MOD_VERSION_CANCEL_BUTTON = "Отмена"
